import { render, staticRenderFns } from "./TextArea.vue?vue&type=template&id=b767c1fc&"
import script from "./TextArea.vue?vue&type=script&lang=js&"
export * from "./TextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b767c1fc')) {
      api.createRecord('b767c1fc', component.options)
    } else {
      api.reload('b767c1fc', component.options)
    }
    module.hot.accept("./TextArea.vue?vue&type=template&id=b767c1fc&", function () {
      api.rerender('b767c1fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/core/Components/Common/Forms/TextArea.vue"
export default component.exports